module.exports = __webpack_public_path__ + "static/img/m_name.c4e2a71.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/mx/m_name.png
// module id = pp7i
// module chunks = 7